import { razorpayxApi } from '@/api'

const actions = {
  link() {
    return razorpayxApi.link()
  },

  check() {
    return razorpayxApi.check()
  }
}

export default {
  actions
}
